import { Route, BrowserRouter as Router, Routes } from "react-router-dom";

import { ContractLicensePage, Home, RedirectLoading, VendorRegistration } from "../pages/index";
function App() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/redirect" element={<RedirectLoading />} />
                <Route path="/vendor_registration" element={<VendorRegistration />} />
                <Route path="/register" element={<ContractLicensePage />} />
            </Routes>
        </Router>
    );
}

export default App;
